import { render, staticRenderFns } from "./OrderBoxLocation.vue?vue&type=template&id=3792abfd&"
import script from "./OrderBoxLocation.vue?vue&type=script&lang=js&"
export * from "./OrderBoxLocation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3792abfd')) {
      api.createRecord('3792abfd', component.options)
    } else {
      api.reload('3792abfd', component.options)
    }
    module.hot.accept("./OrderBoxLocation.vue?vue&type=template&id=3792abfd&", function () {
      api.rerender('3792abfd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwgcontao/js/components/OrderBoxLocation.vue"
export default component.exports